import React from "react";

const StyledLgText = ({ children, fontColor }) => {
  return (
    <p className={`text-lg font-inter font-normal ${fontColor}`}>{children}</p>
  );
};

export default StyledLgText;
